import { MapPin } from "lucide-react";
import { GEOFENCE_PRIVACY_NOTICE } from "@crewledger/shared/geofence";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface GeofenceSubmitModalProps {
  open: boolean;
  title: string;
  description: string;
  overrideReason: string;
  onOverrideReasonChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
  submitting?: boolean;
}

export function GeofenceSubmitModal({
  open,
  title,
  description,
  overrideReason,
  onOverrideReasonChange,
  onCancel,
  onConfirm,
  submitting,
}: GeofenceSubmitModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
        className="w-full max-w-md rounded-xl border bg-card-white p-6 shadow-lg"
        role="dialog"
        aria-modal="true"
        aria-labelledby="geofence-submit-title"
      >
        <div className="mb-4 flex items-start gap-3">
          <div className="rounded-full bg-amber-100 p-2 text-amber-800">
            <MapPin className="h-5 w-5" />
          </div>
          <div>
            <h2 id="geofence-submit-title" className="text-lg font-semibold text-navy-deep">
              {title}
            </h2>
            <p className="mt-1 text-sm text-muted-foreground">{description}</p>
          </div>
        </div>

        <p className="mb-4 text-xs text-muted-foreground">{GEOFENCE_PRIVACY_NOTICE}</p>

        <div className="space-y-2">
          <Label htmlFor="geofence-override">Manager note (optional but recommended)</Label>
          <Input
            id="geofence-override"
            value={overrideReason}
            onChange={(e) => onOverrideReasonChange(e.target.value)}
            placeholder="e.g. Submitted from site trailer, GPS drift"
          />
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm} disabled={submitting}>
            {submitting ? "Submitting…" : "Submit anyway"}
          </Button>
        </div>
      </div>
    </div>
  );
}
